<template>
  <div v-loading="isLoading" class="sku-preview">
    <template v-if="fetchedSku">
      <div v-if="!nonSku" class="sku-preview__content">
        <span><b> Name:</b> {{ fetchedSku.display_name }}</span>
        <span><b> Brand:</b> {{ fetchedSku.brand }}</span>
        <span><b> Producer:</b> {{ fetchedSku.producer }}</span>
        <span><b> Customer ID:</b> {{ fetchedSku.customer_id }}</span>
        <span><b> Size:</b> {{ fetchedSku.size }} {{ fetchedSku.size_unit }}</span>
        <div class="sku-preview__content-image" :style="imageStyle" />
        <template v-if="bus.edit_mode && isUnrecognized === false && nonSku === false && isSku === true">
          <div v-if="!isUnlinkButtonDisabled"
               class="unLink-area"
               @click="bus.unlinkEditMode(skuId)">
            <i class="mdi mdi-link-off" /> UNLİNK SKU
          </div>
        </template>
      </div>
      <div v-else class="sku-preview__content">
        <span v-if="fetchedSku.id"><b> ID:</b> {{ fetchedSku.id }}</span>
        <span v-if="fetchedSku.display_name"><b> Name:</b> {{ fetchedSku.display_name }}</span>
        <span v-if="fetchedSku.non_sku_type"><b> Type:</b> {{ fetchedSku.non_sku_type }}</span>
        <div v-if="fetchedSku.image"
             class="sku-preview__content-image"
             :style="imageStyle" />
      </div>
    </template>
  </div>
</template>

<script>
import { fetchSku } from '@/shared/apis';
import bus from '../sku-validation-scene/bus';

export default {
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    skuId: {
      type: [String, Number],
      required: true
    },
    nonSkuList: {
      type: Array,
      default() {
        return [];
      }
    },
    nonSku: {
      type: Boolean,
      default: false
    },
    isUnrecognized: {
      type: Boolean,
      default: false
    },
    isMeta: {
      type: Boolean,
      default: false
    },
    isCompetitor: {
      type: Boolean,
      default: false
    },
    isSku: {
      type: Boolean,
      default: false
    },
    isUnlinkButtonDisabled: {
      type: Boolean,
      default: false
    },
    cropData: {
      type: Map,
      required: true
    }
  },
  data() {
    return {
      bus,
      fetchedSku: null,
      isLoading: false
    };
  },
  computed: {
    imageStyle() {
      if (!this.fetchedSku) return {};

      if (this.nonSku) return { backgroundImage: `url(${this.fetchedSku.image})` };

      return {
        backgroundImage: `url(${this.fetchedSku.images})`
      };
    }
  },
  watch: {
    skuId() {
      this.fetch();
    },
    nonSku() {
      this.fetch();
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.fetchedSku = null;

      switch (this.skuId) {
        case 'unresolved':
        case 'empty':
        case 'undefined':
          this.fetchedSku = {
            images: '/statics/undefined.svg'
          };
          break;

        default:
          this.fetchSku();
          break;
      }
    },
    async fetchSku() {
      this.fetchedSku = null;
      this.isLoading = true;

      const {
        skuId, projectId, nonSku, nonSkuList
      } = this;

      if (!this.cropData.has(skuId) && !nonSku) {
        const promise = fetchSku(projectId, skuId).then(({ data: { data } }) => data);
        this.cropData.set(skuId, promise);
      }

      try {
        const sku = await this.cropData.get(skuId);

        if (sku) {
          this.fetchedSku = sku;
        } else if (nonSku) {
          const nonSkuItem = nonSkuList.find(item => item.id.toString() === skuId);
          this.fetchedSku = nonSkuItem || { id: this.normalizeString(skuId) };
        }
      } catch (error) {
        console.warn("SKU couldn't fetched", error.message);
      }

      this.isLoading = false;
    }
  }
};
</script>

<style lang="scss">
.sku-preview {
  width: 100%;
  min-width: 200px;
  min-height: 165px;

  &__content {
    display: flex;
    flex: 1;
    flex-direction: column;
    font-size: 13px;

    &-image {
      width: 100%;
      height: 100px;
      margin: 10px auto;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }

    span {
      display: flex;
      justify-content: space-between;
      font-size: 11px;

      b {
        display: inline-block;
        margin-right: 10px;
      }
    }
  }

  .unLink-area {
    width: 100%;
    padding-top: 8px;
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    cursor: pointer;
    border-top: 2px solid #979797;

    span {
      margin-top: 4px;
      font-size: 18px;
      font-weight: 600;
      color: #262626;
    }
  }
}
</style>
